export const generateId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

export const MIN_RESPONSE_DELAY_MS = (typeof process !== "undefined" && process.env?.NODE_ENV === "test") ? 0 : 1200;
